import type { PropType, ExtractPublicPropTypes } from 'vue'
import { apiProps } from '@el-plus/utils/props'
import { formProps } from '@el-plus/components/form'
import { buttonsProps } from '@el-plus/components/buttons'
import type { ButtonProps } from '@el-plus/components/buttons'
import { tableProps } from '@el-plus/components/table'
import { customColumnProps } from '@el-plus/components/custom-column'

export const searchListPageProps = {
  ...apiProps,
  // 自定义列模块
  customColumnModule: {
    ...customColumnProps.module,
  },
  customColumnApi: {
    ...customColumnProps.api,
  },
  customColumnSaveApi: {
    ...customColumnProps.saveApi,
  },
  showOperationColumn: Boolean, // 是否显示操作列
  // 表单列表
  formItemList: {
    ...formProps.formItemList,
  },
  // 左侧按钮
  leftButtons: {
    type: Array as PropType<ButtonProps<any[]>[]>,
    default: () => [],
  },
  // 表格列
  columns: {
    ...tableProps.columns,
  },
  // 列最小宽度
  minWidth: {
    ...tableProps.minWidth,
  },
  // 操作列宽度
  actionColWidth: {
    ...tableProps.actionColWidth,
  },
  // 操作列
  actionButtons: {
    ...tableProps.actionButtons,
  },
  // 格式化列
  formatColumns: {
    ...tableProps.formatColumns,
  },
  showSelectionCol: Boolean,
  showSingleSelectionCol: Boolean,
  showIndexCol: {
    type: Boolean,
    default: true,
  },
  add: Function, // 新增
  clearBefore: Function, // 清空前钩子，返回 false 阻止清空
  // templateDownloadApi: String, // 模板下载
  // importApi: String, // 导入
  // exportApi: String, // 导出
  // 表格额外距离
  offsetTop: {
    type: Number,
    default: 0,
  },
  formData: {
    type: Object,
    default: () => ({}),
  },
  tableProps: Object,
  formProps: Object,
  buttonsProps: Object,
  name: String, // 权限前缀
  // 是否初始化加载数据
  isInitSearch: {
    type: Boolean,
    default: true,
  },
} as const
export type SearchListPageProps = ExtractPublicPropTypes<
  typeof searchListPageProps
>
export const searchListPageEmits = {
  // 点击「清空」按钮后触发
  clear: () => true,
}
export type SearchListPageEmits = typeof searchListPageEmits
